import throttle from 'lodash/throttle';

export default {
  data() {
    return {
      menuVisible: false,
    };
  },

  mounted() {
    this.toggleBackgroundClass();

    // Make mobile nav clicks, close the mobile nave
    document.body.addEventListener('click', (event) => {
      if (event.target.matches('#mobileNav a')) {
        this.toggleMenu();
      }
    });
  },

  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      document.documentElement.classList.toggle('overflow-hidden');
      document.body.classList.toggle('overflow-hidden');
    },
    toggleBackgroundClass() {
      window.addEventListener(
        'scroll',
        throttle((e) => {
          if (window.scrollY > 0) {
            this.$el.classList.remove('bg-transparent');
            this.$el.classList.add('bg-black');
          } else {
            this.$el.classList.remove('bg-black');
            this.$el.classList.add('bg-transparent');
          }
        }, 16)
      );
    },
  },

  render() {
    return this.$scopedSlots.default({
      menuVisible: this.menuVisible,
      toggleMenu: this.toggleMenu,
    });
  },
};
